import {
  REFILL_CREDITS_URL,
  GENERAL_UPGRADE_POPUP_TYPE,
  UPGRADE_POPUP_OPENER_REF
} from 'consts'
import { useSelector } from 'react-redux'
import { userSelectors } from 'store/features/user/selectors'
import { FREE_PLAN_ID, LITE_PLAN_ID } from 'consts/user'

interface IOpenUpgradePopupProps {
  ref: string
}

interface IUseOpenUpgradePopupOptions {
  usePlanCheck?: boolean
}

export const useOpenUpgradePopup = (options?: IUseOpenUpgradePopupOptions) => {
  const isFreeUser = useSelector(userSelectors.isFreeUser)
  const userCurrentPlanId = useSelector(userSelectors.userCurrentPlanId)

  const openUpgradePopup = ({ ref }: IOpenUpgradePopupProps = { ref: '' }) => {
    const shouldShowUpgradePopup = options?.usePlanCheck
      ? userCurrentPlanId === FREE_PLAN_ID || userCurrentPlanId === LITE_PLAN_ID
      : isFreeUser

    if (shouldShowUpgradePopup) {
      window.openUpgradePopup({
        type: GENERAL_UPGRADE_POPUP_TYPE,
        openerRef: UPGRADE_POPUP_OPENER_REF
      })
    } else {
      window.open(`${REFILL_CREDITS_URL}?ref=${ref}`, '_blank')
    }
  }

  return openUpgradePopup
}
